import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Upload from "@/pages/Upload";
import StatementView from "@/pages/StatementView";
import Transactions from "@/pages/Transactions";
import Attention from "@/pages/Attention";
import Parties from "@/pages/Parties";
import Bills from "@/pages/Bills";
import Reconciliation from "@/pages/Reconciliation";
import Suspense from "@/pages/Suspense";
import Export from "@/pages/Export";
import Reports from "@/pages/Reports";
import Audit from "@/pages/Audit";
import SettingsPage from "@/pages/Settings";
import BankAccounts from "@/pages/BankAccounts";
import Login, { ChangePassword } from "@/pages/Login";

function Shell() {
  const { authUser, setAuthUser, ready, biz, user, theme, logout } = useApp();
  if (authUser === false) return <><Login /><Toaster theme={theme} richColors position="bottom-right" /></>;
  if (!authUser || !ready) return <div className="grid min-h-screen place-items-center text-sm text-muted-foreground">Loading ROXY LEDGER AI…</div>;
  if (authUser.must_change_password) return (
    <div className="grid min-h-screen place-items-center p-6"><div className="panel w-full max-w-md p-8"><h2 className="mb-4 text-2xl font-extrabold">Set a new password</h2>
      <ChangePassword forced onDone={() => window.location.reload()} />
      <button onClick={logout} className="mt-4 text-xs text-muted-foreground hover:underline" data-testid="forced-change-logout">Sign out</button></div><Toaster theme={theme} richColors /></div>
  );
  return (
    <Layout>
      <div key={`${biz}-${user?.id}`}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/accounts" element={<BankAccounts />} />
          <Route path="/statements/:id" element={<StatementView />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/attention" element={<Attention />} />
          <Route path="/parties" element={<Parties />} />
          <Route path="/bills" element={<Bills />} />
          <Route path="/reconciliation" element={<Reconciliation />} />
          <Route path="/suspense" element={<Suspense />} />
          <Route path="/export" element={<Export />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </div>
      <Toaster theme={theme} richColors position="bottom-right" />
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider><Shell /></AppProvider>
    </BrowserRouter>
  );
}
